<div class="actions-grid-container" #requests>
  <hs-requests-grid
    ($requestRowSelected)="onRequestSelected($event)"
    [isRequestLoading]="isRequestLoading"
    [refreshRequest]="refreshRequest"
  ></hs-requests-grid>
</div>
<div class="notes-section textarea mt-3">
  <nf-form-control
    class="notes-control"
    label="Notes"
    for="pendingRequestNotes"
    [customErrorMessages]="validationMessages.requestNotesValidationMessages"
  >
    <textarea
      id="reviewerComments"
      class="form-control"
      ngbAutofocus
      [formControl]="pendingRequestNotes"
      rows="2"
    ></textarea>
  </nf-form-control>
</div>
<div class="approval-action-btn">
  <button
    nf-button="primary"
    [title]="getErrorMessage(rDenyBtnErrorMessage)"
    [disabled]="
      !selectedRequest ||
      pendingRequestCount == 0 ||
      rDenyBtnErrorMessage.size > 0 ||
      pendingRequestNotes.invalid
    "
    (click)="denyRequest('request', selectedRequest)"
  >
    Deny ({{ pendingRequestCount }}
    {{
      pendingRequestCount == 0 || pendingRequestCount > 1
        ? 'Requests'
        : 'Request'
    }}
    Selected)
  </button>
  <button
    nf-button="primary"
    [title]="getErrorMessage(rApproveBtnErrorMessage)"
    [disabled]="
      !selectedRequest ||
      pendingRequestCount == 0 ||
      rApproveBtnErrorMessage.size > 0 ||
      pendingRequestNotes.invalid
    "
    (click)="approveRequest('request', selectedRequest)"
  >
    Approve ({{ pendingRequestCount }}
    {{
      pendingRequestCount == 0 || pendingRequestCount > 1
        ? 'Requests'
        : 'Request'
    }}
    Selected)
  </button>
</div>
<div class="horizontal-line"></div>
<hs-resize-handle
  [elem1]="requests"
  [elem2]="subPanels"
  [initialResizeHandleState]="state?.resizeHandleState"
  (resizeFinished)="onResizeFinished($event)"
></hs-resize-handle>

<div id="details-sub-panels" #subPanels>
  <ng-container *ngIf="selectedRequest; else noSelectedRequest">
    <hs-panel-card
      *ngIf="hasMixedActionTypes"
      header="Multiple Request Types Selected"
    >
      <p>
        Multiple action types are selected. Please select requests of the same
        action type to view details.
      </p>
    </hs-panel-card>

    <hs-request-detail-grid-force-recon
      *ngIf="!hasMixedActionTypes && selectedActionType === 'FORCE_RECON'"
      [selectedRequest]="selectedRequest"
      [refreshRequestDetails]="refreshRequestDetails"
      (requestDetailsSelectedRow)="onRequestDetailsSelected($event)"
      (refreshRequest)="setRefreshRequest($event)"
    ></hs-request-detail-grid-force-recon>

    <hs-request-detail-grid-restricted-breaks
      *ngIf="!hasMixedActionTypes && selectedActionType === 'RESTRICTED_BREAK'"
      [selectedRequest]="selectedRequest"
      (refreshRequest)="setRefreshRequest($event)"
    ></hs-request-detail-grid-restricted-breaks>

    <div
      *ngIf="
        selectedRequest && !hasMixedActionTypes && allowDetailLevelApprovals
      "
    >
      <div class="notes-section textarea mt-3">
        <nf-form-control
          class="notes-control"
          label="Notes"
          [customErrorMessages]="
            validationMessages.requestNotesValidationMessages
          "
        >
          <textarea
            id="reviewerComments"
            class="form-control"
            [formControl]="pendingRequestDetailsNotes"
            ngbAutofocus
            rows="2"
          ></textarea>
        </nf-form-control>
      </div>
      <div class="approval-action-btn">
        <button
          nf-button="primary"
          [title]="getErrorMessage(rdDenyBtnErrorMessage)"
          (click)="denyRequest('request-detail', selectedRequestDetails)"
          [disabled]="
            !selectedRequestDetails ||
            pendingRequestDetailsCount == 0 ||
            rdDenyBtnErrorMessage.size > 0 ||
            pendingRequestDetailsNotes.invalid
          "
        >
          Deny ({{ pendingRequestDetailsCount }}
          {{
            pendingRequestDetailsCount == 0 || pendingRequestDetailsCount > 1
              ? 'Accounts'
              : 'Account'
          }}
          Selected)
        </button>
        <button
          nf-button="primary"
          [title]="getErrorMessage(rdApproveBtnErrorMessage)"
          (click)="approveRequest('request-detail', selectedRequestDetails)"
          [disabled]="
            !selectedRequestDetails ||
            pendingRequestDetailsCount == 0 ||
            rdApproveBtnErrorMessage.size > 0 ||
            pendingRequestDetailsNotes.invalid
          "
        >
          Approve ({{ pendingRequestDetailsCount }}
          {{
            pendingRequestDetailsCount == 0 || pendingRequestDetailsCount > 1
              ? 'Accounts'
              : 'Account'
          }}
          Selected)
        </button>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noSelectedRequest
  ><hs-panel-card
    *ngIf="!selectedRequest || selectedRequest.length === 0"
    header="No Requests Selected"
  >
    <p>
      This panel requires a request to be selected before information can be
      displayed. Select a request to continue.
    </p>
  </hs-panel-card>
</ng-template>
